define('views/content/reset_password',['require','backbone','marionette','jquery-validation','select2','text!templates/content/reset_password.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');
    require('select2');

    var temp = require("text!templates/content/reset_password.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        initialize: function (options) {
            this.code = options.code;
        },

        ui: function() {
            return {
                mainForm : '#main-form',
                passwordField: '#password',
                passwordConfirmField: '#password_confirm',
                submitButton: '#submit-button'
            };
        },

        events: {
            'click @ui.submitButton': 'submitButtonClicked'
        },

        onRender: function () {
            this.ui.mainForm.validate({
                rules: {
                    'password': "required",
                    'password_confirm': {
                        equalTo: '[name="password"]'
                    }
                },
                messages: {
                    'password': App.polyglot.t('password_required'),
                    'password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    }

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {

                this.ui.submitButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'auth/password-reset/' + this.code + '/reset_password/',
                    method: 'post',
                    data: {
                        password: this.ui.passwordField.val(),
                        password_confirm: this.ui.passwordConfirmField.val()
                    },
                    success:function(response) {
                        _this.ui.submitButton.removeClass('loading');

                        App.utils.showMessage('success', App.polyglot.t('password_reset_success'));
                        App.context.redirect('/');
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.submitButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            }
        }


    });
});
